import { render, staticRenderFns } from "./ItineraryModules.vue?vue&type=template&id=4954faf8&"
import script from "./ItineraryModules.vue?vue&type=script&lang=js&"
export * from "./ItineraryModules.vue?vue&type=script&lang=js&"
import style0 from "./ItineraryModules.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports